'use strict';

module.exports = {
    LANG: 'zh-cn',
    SIGN: '登录',
    REGISTER: '注册',
    QUICK_ACCESS: '快速登录',
    SIGN_JOIN: '登录或者免费注册！',
    NOT_MEMBER: '不是注册会员？',
    ALREADY_MEMBER: '已是AliExpress或Alibaba注册会员？',
    SHOW_ALL: '展示全部',
    HIDE: '隐藏'
};